<template>
  <div class="tag-filter-bar">
    <button
      v-for="tag in tags"
      :key="tag"
      :class="['tag-chip', { active: modelValue.includes(tag) }]"
      @click="toggle(tag)"
      type="button"
    >
      {{ tag }}
    </button>
    <button v-if="modelValue.length > 0" class="tag-chip clear" type="button" @click="$emit('update:modelValue', [])">
      Clear
    </button>
  </div>
</template>

<script>
import { AVAILABLE_TAGS } from '../tags';

export default {
  name: 'TagFilterBar',
  props: {
    modelValue: { type: Array, default: () => [] },
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const toggle = (tag) => {
      const next = props.modelValue.includes(tag)
        ? props.modelValue.filter((t) => t !== tag)
        : [...props.modelValue, tag];
      emit('update:modelValue', next);
    };

    return { tags: AVAILABLE_TAGS, toggle };
  },
};
</script>

<style scoped>
.tag-filter-bar {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  max-width: 100%;
}

.tag-chip {
  border: 1px solid #ccc;
  background: white;
  border-radius: 999px;
  padding: 5px 12px;
  font-size: 12px;
  cursor: pointer;
  white-space: nowrap;
}

.tag-chip.active {
  background-color: #2d7a3a;
  border-color: #2d7a3a;
  color: white;
}

.tag-chip.clear {
  color: #a33;
  border-color: #a33;
}
</style>
